import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import { CustomerProfilResponse } from "@/core/customers/entities";
import { CustomerProfilMapper } from "@/core/customers/mappers/CustomerProfilMapper";
import type { CustomerProfilApiResponse } from "@/core/customers/mappers/CustomerProfilMapper";
import CustomerProfilRepository from "@/core/customers/repositories/CustomerProfilRepository";

export default class GetCustomerProfilUseCase {
  constructor(
    private readonly customerProfilRepository: CustomerProfilRepository
  ) {}

  /**
   * Executes the get customer profil use case.
   *
   * @param businessKey - The business key of the customer
   * @returns A promise resolving with a CustomerProfilResponse containing the mapped domain model
   * @throws {Exception} If an exception occurs during execution
   */
  async execute(businessKey: string): Promise<CustomerProfilResponse> {
    try {
      // Récupération des données brutes de l'API
      const apiResponse = await this.customerProfilRepository.getCustomerProfil(
        businessKey
      );

      // Transformation de la réponse API vers le modèle de domaine
      const domainModel = CustomerProfilMapper.toDomainModel(
        apiResponse.data as unknown as CustomerProfilApiResponse
      );

      // Construction de la réponse avec le modèle de domaine transformé
      return {
        code: apiResponse.code,
        message: apiResponse.message,
        data: domainModel,
      };
    } catch (e) {
      if ((e as Exception).type) {
        throw e;
      } else {
        throw { type: DefaultExceptionTypes.UNKNOWN_ERROR, body: e };
      }
    }
  }
}
